import React from 'react'

import TextArea from '../Fields/TextArea'
import SingleInput from '../Fields/SingleInput'

const ModuleEighteen = (props) => {

	return (
		<div>
			<div>
				I have been informed by Dr.
				<SingleInput
					name={"paragraph1"}
					id={"field1"}
					controlFunc={props.addToForm}
					inputType={"text"}
					placeholder={"Doctor Name"}
					value={props.consentForm.paragraph1.field1}
				/>
				of my current condition and recommendation for treatment which includes:
				<TextArea
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"paragraph1"}
					id={"field2"}
					placeholder={"i.e., implant, sinus lift, cleft palate, orthognathic, etc."}
					value={props.consentForm.paragraph1.field2}
				/>
			</div>

			<div>
				I also understand that a separate procedure to obtain bone for grafting is intended to remove portions of bone from my 
				<SingleInput
					name={"paragraph1"}
					controlFunc={props.addToForm}
					inputType={"text"}
					id={"field3"}
					placeholder={"hip, leg, jaw, etc."}
					value={props.consentForm.paragraph1.field3}
				/>
				and place it in the area to be treated.
			</div>
		</div>
	)
}

export default ModuleEighteen


// WEBPACK FOOTER //
// ./src/components/Modules/18.js